import styled from '@emotion/styled';

export const PC_HEADER_HEIGHT = 49;
export const SP_HEADER_HEIGHT = 44;

export const Header = styled.div((props: { isMobile: boolean }) => ({
  maxWidth: 'auto',
  overflowX: 'clip',
  '._n4v1-header': {
    lineHeight: 1.6,
    ...(props.isMobile
      ? {
          '._n4v1-global-service': {
            '&-icon, &-hasfloor::after': {
              boxSizing: 'content-box',
            },
          },
        }
      : {
          minWidth: '350px',
          '._n4v1-login-heading': {
            lineHeight: 1,
          },
        }),
  },
}));

export const HeaderFallback = styled.div((props: { isMobile: boolean }) => ({
  position: 'relative',
  display: 'block',
  width: '100%',
  minWidth: props.isMobile ? undefined : '350px',
  height: `${props.isMobile ? SP_HEADER_HEIGHT : PC_HEADER_HEIGHT}px`,
  boxSizing: 'content-box',
  backgroundColor: '#fff',
  borderBottom: `1px solid ${
    props.isMobile ? '#f7f7f7' : 'rgb(233, 235, 239)'
  }`,
}));

export const AntiLayoutShift = styled.div((props: { isMobile: boolean }) => ({
  display: 'block',
  minHeight: `calc(100vh - ${
    (props.isMobile ? SP_HEADER_HEIGHT : PC_HEADER_HEIGHT) + 1
  }px)`,
}));
